"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgenticExtractionFailedEvent = exports.AgenticExtractionCompletedEvent = exports.AgenticExtractionStartedEvent = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
const AgenticExtraction_1 = require("../../AgenticExtraction");
const agenticExtractionEventBase = {
    extractor: zod_1.z.nativeEnum(AgenticExtraction_1.AgenticExtractorName),
    extractorVersion: zod_1.z.number().int(),
    packageId: zod_1.z.string(),
    fileId: zod_1.z.string(),
    runId: zod_1.z.string(),
};
exports.AgenticExtractionStartedEvent = (0, event_1.createEventClass)('AgenticExtractionStartedEvent', zod_1.z.object({ ...agenticExtractionEventBase }));
exports.AgenticExtractionCompletedEvent = (0, event_1.createEventClass)('AgenticExtractionCompletedEvent', zod_1.z.object({ ...agenticExtractionEventBase, outcome: zod_1.z.nativeEnum(AgenticExtraction_1.AgenticExtractionRunStatus) }));
exports.AgenticExtractionFailedEvent = (0, event_1.createEventClass)('AgenticExtractionFailedEvent', zod_1.z.object({ ...agenticExtractionEventBase, errorMessage: zod_1.z.string() }));
//# sourceMappingURL=agentic-extraction-events.js.map